import React, {useState, useEffect, Fragment} from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { MdAccountBox } from "react-icons/md";
import { GiLetterBomb, GiMoneyStack } from "react-icons/gi";
import { BsFillCalculatorFill } from "react-icons/bs";
import { BsBank } from "react-icons/bs";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { AiOutlineFileSearch } from "react-icons/ai";
import {useDispatch, useSelector} from 'react-redux'
import {  CarpetaDigitalComponent, CambioTipoGestionComponent, SolicitudDescuentoComponent, TrazabilidadHitosComponent, CartaCIAComponent} from 'reccol-caso-general'
import { ConsultaProcesosJudicialesComponent, ConsultaGastosHonorariosComponent, ConsultaContactoImplicadoComponent } from 'defcol-caso-general';
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import {makeStyles} from '@material-ui/core/styles'
import { useLocation, useNavigate } from 'react-router-dom'
import { validaConvenio, validaNumeros, isValidParam, formatearNumero } from '../../common/Formatos';
import { Filter } from '@material-ui/icons';
import Bitacora from '../bitacora';
import Mensajes from '../mensajes';

const useStyles = makeStyles((theme) => ({
    root: {
     height: 380,
      transform: 'translateZ(0px)',
      flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '150px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */        
    },
    menu: {
      width: '50px',
      height: '50px',      
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
const Formulario = ({formik,setShowToast, showToast, setIsRechaza,setIsAjustado,loading,setMontoNetoCompara, setMontoAjustadoNoFormat}) => {
const {state}=useLocation()
const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
const history =useNavigate()

const classes = useStyles();  
const classesTooltip = useStylesToltip();
const [showCambiar, setShowCambiar] = useState(false) 
  
const [open, setOpen] = React.useState(false);
const [hidden, setHidden] = React.useState(false);
const [showCIA, setShowCIA] = useState(false)
const [showSolicitud, setShowSolicitud] = useState(false)
const [showTraza, setShowTraza] = useState(false)
const [showBitacora, setShowBitacora] = useState(false)
const [estadoSolicitud, setEstadoSolicitud] = useState('')
const [porcAjustado, setPorcAjustado] = useState('')
const [miMontoNeto, setMiMontoNeto] = useState('')
const [montoAjustado, setMontoAjustado] = useState('')
const [montoAjustadoNoFormato, setMontoAjustadoNoFormato] = useState('')
const [comentario, setComentario] = useState('')
const [showCarpeta, setShowCarpeta] = useState(false)
const [monedaSD, setMonedaSD] = useState('')

const handleShowBitacora = () => setShowBitacora(true)
const handleCloseBitacora= () => setShowBitacora(false)

  const handleCloseCIA = () => setShowCIA(false)
  const handleCloseSolicitud = () => setShowSolicitud(false)
  const handleCloseTraza = () => setShowTraza(false) 

  const handleShowCIA = () => setShowCIA(true)
  const handleShowSolicitud = () => setShowSolicitud(true)
  const handleShowTraza = () => setShowTraza(true)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)

  const [showProcesosJudiciales, setShowProcesosJudiciales] = useState(false);
  const handleShowProcesosJudiciales = () => setShowProcesosJudiciales(true)

  const [showGastosHonorarios, setShowGastosHonorarios] = useState(false);
  const handleShowGastosHonorarios = () => setShowGastosHonorarios(true)

  const [showContactoImplicado, setShowContactoImplicado] = useState(false);
  const handleShowContactoImplicado = () => setShowContactoImplicado(true)

  const dispatch = useDispatch()

  useEffect(() => {
    setMontoAjustadoNoFormat(montoAjustadoNoFormato)  
  }, [montoAjustadoNoFormato])

  useEffect(()=>{
    setMontoNetoCompara(miMontoNeto)
  },[miMontoNeto]) 
  const handleCloseCambiar = () => {
    setShowCambiar(false)
    
  }
  const handleShowCambiar = () => setShowCambiar(true)
  const handleOpen = () => {
    setOpen(true);
  };
  const handleCloseAction = () => {
    setOpen(false);
  };
  const handleAction = (action) => {
    if(action ==="14_10"){
        
        handleShowContactoImplicado() 
    } else if(action ==="14_11"){
      
        handleShowCIA()       
    } else if(action ==="14_12"){      
      
        handleShowSolicitud()             
    } else if(action ==='14_13'){
     
        handleShowProcesosJudiciales() 
    } else if(action ==='14_14'){
     
        handleShowTraza() 
    } else if(action ==='14_23'){
     
      handleShowGastosHonorarios() 
    }
  };

    const data_antender = useSelector((state) => state.atenderSolicitudReducer)
    const {cfg_form29,datosSolicitudDescuento,comboAprobacion,respuestaProcesar} = data_antender
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado

    useEffect(()=>{
        setMiMontoNeto(datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoNeto']) ? datosSolicitudDescuento.datosSolicitudDescuento[0]['montoNeto'] : '')
        setMonedaSD(datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['idMonedaSolDcto']) ? datosSolicitudDescuento.datosSolicitudDescuento[0]['idMonedaSolDcto'] : '')
    },[datosSolicitudDescuento])

    useEffect(()=>{
        if(respuestaProcesar && respuestaProcesar.respuestaProcesar["code"]===1){
           setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),2000)      
        }
    },[respuestaProcesar])

    const actions = [
        
        { icon: <AiOutlineFileSearch  size={30} style={{color:'#00aeab'}}/>, name: cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-menu-lateral-hitos' ]:'',id:'14_14'},        
        { icon: <BsFillCalculatorFill  size={30} style={{color:'#00aeab'}}/>, name:cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-subtitle2-solicitud']:'',id:'14_12' },
        { icon: <GiLetterBomb  size={40} style={{color:'#00aeab'}}/>, name: cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-menu-lateral-carta']:'',id:'14_11' },
        {  icon: <GiMoneyStack  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-menu-lateral-gastos']:'', id:'14_23'} ,
        {  icon: <BsBank  size={30} style={{color:'#00aeab'}}/>, name: cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-menu-lateral-antecjud']:'' ,id:'14_13'},
        {  icon: <MdAccountBox  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-menu-lateral-ctotro']:'', id:'14_10'} ,
       
      ];
      const handleCloseToast = () => {
        setShowToast(false);
      }
       return (
        <>
            <style type='text/css'>
        {`
        .cardHeader {
            background-color: #77789b;
            color: #FFFFFF;
          }
        .btn-carpeta {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;        
        }
        .btn-carpeta:hover{
            background-color:#e1b97f;
            color: #FFFFFF;
        }
        .btn-bitacora {
            background-color: #55B2CE;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-bitacora:hover{
            background-color: #87c9dc;
            color: #FFFFFF;
        } 
        .btn-cambiar {
            background-color:  #286FBF;
            color: #FFFFFF;
            width: 140px;     
            padding:6px 0px 6px 0px;
        }
        .btn-cambiar:hover{
            background-color:  #5b9ad1;
            color: #FFFFFF;
        }
        .btn-actualizar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-actualizar:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        }
        .btn-recepcionar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-recepcionar:hover{
            background-color: #F6897E;
            color: #FFFFFF;
        }
        .btn-volver {    
            color: #66CCCC;
            border: 1px solid #C00     
            width: 140px;
        }
        .btn-tamano{
            padding: 1rem 1.5rem;
            font-size: 1.5rem;
        }
    `}
      </style>
      <Bitacora
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      />

      <Modal show={showCambiar} onHide={handleCloseCambiar} size='xl'>
        <CambioTipoGestionComponent handleClose={handleCloseCambiar} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
      </Modal>
  
      <Modal show={showCIA} onHide={handleCloseCIA} size='xl'>
        <CartaCIAComponent handleClose={handleCloseCIA} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={8600399880}
        />          
      </Modal>
      <Modal show={showSolicitud} onHide={handleCloseSolicitud} size='xl'>
        <SolicitudDescuentoComponent handleClose={handleCloseSolicitud} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
      </Modal>

      <Modal show={showTraza} onHide={handleCloseTraza} size='xl' >
        <TrazabilidadHitosComponent handleClose={handleCloseTraza} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
        />          
      </Modal>
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
            idCaso={llaves && llaves['idCaso']}
            idImplicado={llaves && llaves['idImplicado']}
            idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={2}            
          />                
    </Modal>
    <ConsultaContactoImplicadoComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
          showModal={showContactoImplicado}
          setShowModal={setShowContactoImplicado}
      />
    <ConsultaProcesosJudicialesComponent
        idCaso={llaves?.idCaso}
        idOrgCaso={llaves?.idOrgCaso}
        tipoGestion={207001}//{antecedentesCaso && antecedentesCaso[0]?.IdTipoGestion}
        showModal={showProcesosJudiciales}
        setShowModal={setShowProcesosJudiciales}
    />
    <ConsultaGastosHonorariosComponent
          idCaso={llaves?.idCaso}
          idOrgCaso={llaves?.idOrgCaso}
          showModal={showGastosHonorarios}
          setShowModal={setShowGastosHonorarios}
    />
    <Container className='mb-4 mt-2 position-relative'>
      <div>           
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                className={classes.speedDial}
                hidden={hidden}
                icon={<AiOutlineMenuUnfold size={30} />}
                onClose={handleCloseAction}
                onOpen={handleOpen}
                open={true}             
            >
            { actions.map((action) => (
                <SpeedDialAction
                    key={action.id}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    className={classes.menu}                
                    onClick={()=>handleAction(action.id)}
                    TooltipClasses={classesTooltip}                
                />            
            ))}
            </SpeedDial>
            </div>

            <Card>
                <Card.Header className='mt-0 mb-0' as='h6'
                    style={
                        {
                            backgroundColor: '#4F517A',
                            color: 'white'
                        }
                }>
                    {
                    cfg_form29 ? cfg_form29.cfg_form29['atiendesoldcto-title-antec'] : ''
                } </Card.Header>
                <Container>
                    <Container> {
                        cfg_form29 ? (
                            <div>

                                <Row>
                                    
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-ambito']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['ambitoGestion'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['ambitoGestion'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['ambitoGestion'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['ambitoGestion']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-usuario']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['usuarioSolDcto'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['usuarioSolDcto'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['usuarioSolDcto'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['usuarioSolDcto']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-fechasol'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['fecSolDctoFormat'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['fecSolDctoFormat'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['fecSolDctoFormat'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['fecSolDctoFormat']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                    <div className='d-flex flex-row justify-content-space-beetwen'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        width:'200px',
                                                    }
                                            }>
                                                {
                                                    cfg_form29.cfg_form29['atiendesoldcto-subtitle1-solicitud'] 
                                            } </Form.Label>
                                    
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',                                                  
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                   
                                </Row>
                                    <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-moneda']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaRecobro'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaRecobro'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaRecobro'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaRecobro']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-mtoneto']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                            {datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoNeto']) ?
                                                formatearNumero(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoNeto'], 
                                                    !monedaSD == 30001) 
                                            : ''
                                            } 
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-porcrec'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2 mx-4">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcRecobro'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcRecobro'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcRecobro'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['porcRecobro']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-mtorecobro'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                            {datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoRecobro']) ?
                                                formatearNumero(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoRecobro'], 
                                                    !monedaSD == 30001) 
                                            : ''
                                            }
                                        </Form.Text>

                                       </Col>
                                </Row>
                                     </Container>  
                               
                                <Row>
                                    <Col>
                                    <div className='d-flex flex-row'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        width:'200px',
                                                    }
                                            }>
                                                {
                                                cfg_form29.cfg_form29['atiendesoldcto-subtitle2-solicitud'] 
                                            } </Form.Label>
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',                                                   
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                </Row>
                                    <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-monedasoldcto']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaSolDcto'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaSolDcto'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaSolDcto'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['monedaSolDcto']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-propuestarec']
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                            {datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoPropuestoSolDcto']) ?
                                                formatearNumero(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoPropuestoSolDcto'], 
                                                    !monedaSD == 30001) 
                                            : ''
                                            } 
                                        </Form.Text>

                                       </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-porcpropto'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2 mx-4">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                    
                                </Row>
                                     </Container>  
                                     <Container>
                                        <Row>
                                        <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-motivodcto'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['motivoSolDcto'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['motivoSolDcto'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['motivoSolDcto'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['motivoSolDcto']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                       <Col md='9'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-comentario'] 
                                        } </Form.Label>
                                        <br/>
                                        <Form.Text className="mt-2">
                                        {datosSolicitudDescuento &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['comentarioSolDcto'] !== undefined &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['comentarioSolDcto'] !== null &&
                                            datosSolicitudDescuento.datosSolicitudDescuento[0]['comentarioSolDcto'] !== ''
                                            ? datosSolicitudDescuento.datosSolicitudDescuento[0]['comentarioSolDcto']
                                            : ''}
                                        </Form.Text>

                                       </Col>
                                        </Row>
                                     </Container>
                                     <Row>
                                    <Col>
                                    <div className='d-flex flex-row'>
                                        <Form.Label className='mb-0 mt-3'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px'
                                                    }
                                            }>
                                                {
                                                cfg_form29.cfg_form29['atiendesoldcto-subtitle3-aprobacion'] 
                                            } </Form.Label>
                                            <hr style={
                                                {
                                                    color: '#04005D',
                                                    height: '2px',
                                                    width:'82%',
                                                    marginLeft:'7rem',
                                                    marginTop: '30px'
                                                }
                                            }></hr>
                                    </div>
                                    </Col>
                                </Row>
                                <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                           Estado * </Form.Label>
                                        <br/>
                                        <Form.Select
                                            className='mt-2'
                                            aria-label='Default select example'                       
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                setEstadoSolicitud(e.target.value)       
                                                let porcSD = datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto']) ? datosSolicitudDescuento.datosSolicitudDescuento[0]['porcPropuestoSolDcto'] : ''
                                                let montoSD = datosSolicitudDescuento && isValidParam(datosSolicitudDescuento.datosSolicitudDescuento[0]['montoPropuestoSolDcto']) ? datosSolicitudDescuento.datosSolicitudDescuento[0]['montoPropuestoSolDcto'] : ''                                                
                                                
                                                if (parseInt(e.target.value)===248001 ) {
                                                    setPorcAjustado(porcSD)
                                                    setMontoAjustado(formatearNumero(montoSD, !monedaSD == 30001))                                                
                                                    setIsRechaza(false)
                                                    setIsAjustado(false)
                                                } else if (parseInt(e.target.value)===248002) {
                                                    setMontoAjustado('')
                                                    setPorcAjustado('')
                                                    setIsRechaza(false)
                                                    setIsAjustado(true)
                                                } else if (parseInt(e.target.value)===248003 ) {
                                                    setIsRechaza(true)
                                                    setIsAjustado(false)
                                                    setMontoAjustado(0)
                                                    setPorcAjustado(0)                                                
                                                }                                        
                                            }}
                                            name='estadoSolicitud'
                                            value={(formik.values.estadoSolicitud = estadoSolicitud)}
                                            error={formik.errors.estadoSolicitud}
                                        >
                                            <option value={''}>Seleccione...</option>
                                            {comboAprobacion &&
                                            comboAprobacion.comboAprobacion?.filter(c=>c.accion===1)?.map((c) => (
                                                <option key={c.id} value={c.id}>
                                                {c.nombre}
                                                </option>
                                            ))}
                                    </Form.Select>
                                        {formik.errors.estadoSolicitud ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.estadoSolicitud}</Form.Text>) :""}
                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-porcajustado']+" (*)"
                                        } </Form.Label>
                                        <br/>
                                        <Form.Control
                                                className='mt-2'
                                                aria-label='Default select example' 
                                                disabled={parseInt(estadoSolicitud)!==248002 }                   
                                                onKeyDown={e=>validaConvenio(e)}
                                                type="number"
                                                onChange={e=>{                    
                                                    formik.handleChange(e)
                                                    setPorcAjustado(e.target.value)
                                                    if (isValidParam(miMontoNeto)) {        
                                                
                                                        let porcAju = e.target.value;
                                                        let montoAju = (miMontoNeto*porcAju) / 100;
                                                        setMontoAjustado(formatearNumero(montoAju, !monedaSD == 30001));                                                                                           
                                                        setMontoAjustadoNoFormato(montoAju);
                                                    
                                                    } else {
                                                        setMontoAjustado(0)
                                                    }
                                                    
                                                    }}
                                                onBlur={()=>{                 
                                                    if(porcAjustado!==""){
                                                        setPorcAjustado(parseFloat(porcAjustado).toFixed(2).split(".")[1]==="00"?porcAjustado:parseFloat(porcAjustado).toFixed(2))
                                                    } else {
                                                        setPorcAjustado("")
                                                    }
                                                }}
                                                name='porcAjustado'                                            
                                                value={formik.values.porcAjustado =porcAjustado}
                                                error={formik.errors.porcAjustado}        
                                            ></Form.Control>
                                           {formik.errors.porcAjustado ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.porcAjustado}</Form.Text>) :""}

                                       </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-recobajustado']+" (*)" 
                                        } </Form.Label>
                                        <br/>
                                         <Form.Control
                                            className='mt-2'
                                            autoComplete='off'
                                            disabled={parseInt(estadoSolicitud)!==248002 }
                                            aria-label='Default select example'
                                            onKeyDown={e=>validaNumeros(e)}
                                            onBlur={()=>setMontoAjustado(formatearNumero(montoAjustado, !monedaSD == 30001))}
                                            onFocus={()=>setMontoAjustado(montoAjustadoNoFormato)}
                                            onChange={e=>{                    
                                                formik.handleChange(e)
                                                setMontoAjustado(e.target.value)
                                                setMontoAjustadoNoFormato(e.target.value)
                                                if (miMontoNeto !== "" && miMontoNeto !==null && miMontoNeto !==undefined){                                                
                                                    setPorcAjustado(parseFloat(e.target.value*100/miMontoNeto).toFixed(2))
                                                } else {
                                                    setPorcAjustado(0)
                                                }
                                            }}
                                            name='montoAjustado'                                
                                            value={formik.values.montoAjustado =montoAjustado}
                                            error={formik.errors.montoAjustado} 
                                        ></Form.Control>
                                          {formik.errors.montoAjustado ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.montoAjustado}</Form.Text>) :""}
                                       </Col>
                                    <Col md='5'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form29.cfg_form29['atiendesoldcto-lbl-comentarioaprob'] 
                                        } </Form.Label>
                                        {"\u00A0"}
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '10px'
                                                }
                                        }>
                                            (se incluye a notificación de respuesta) </Form.Label>
                                        <br/>
                                        <Form.Control as="textarea" rows={3} 
                                        className='mt-2 mb-2'
                                            onChange={e=>{                    
                                                formik.handleChange(e)
                                            setComentario(e.target.value)
                                                
                                                }}
                                            name='comentario'
                                        
                                            value={formik.values.comentario =comentario          
                                            }
                                            error={formik.errors.comentario}  

                                        />
                                        {formik.errors.comentario ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.comentario}</Form.Text>) :""}

                                       </Col>
                                </Row>
                                     </Container>
                                     <Col>
                                    {respuestaProcesar && 
                                        <Mensajes
                                            showToast={showToast}
                                            handleCloseToast={handleCloseToast}
                                            delay={5000}
                                            responseData={respuestaProcesar?.respuestaProcesar}
                                        ></Mensajes>
                                    }
                                    </Col>
                                </div>
                                
                        ) : null
                    } </Container>
                </Container>
                <Container>
                    <Row className='mt-2'>                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-gestion-compania',{state:{queryState}} )}  >
                                {cfg_form29 && cfg_form29.cfg_form29["atiendesoldcto-btn-volver"]}
                            </Button>
                            <Button className='m-2' variant='bitacora' onClick={handleShowBitacora} >
                                {cfg_form29 && cfg_form29.cfg_form29["atiendesoldcto-btn-bitacora"]}
                            </Button>
                            <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta} name='carpeta'>
                                {cfg_form29 && cfg_form29.cfg_form29["atiendesoldcto-btn-carpeta"]}
                            </Button>                        
                            <Button className='m-2' variant='actualizar' type='onSubmit' name='actualizar'>
                                {cfg_form29 && cfg_form29.cfg_form29["atiendesoldcto-btn-procesar"]}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card>
        </Container>
        </>
    )
}

export default Formulario
